import React from 'react';
import BaseRow from '../BaseRow';
import styles from './index.module.scss';

const BodyRow = ({ children }) => {
  return <BaseRow className={styles.root}>{children}</BaseRow>;
};

export default BodyRow;
